import { v4 } from "uuid";

export const typeColorCondition = {
  waitlist: "orange",
  inquiry: "#6669ff",
  prospect: "#E06A5C",
  customer: "green",
  contacted: "lightblue",
  vendor: "grey",
  vip: "#03fcc2",
  designer: "#ba03fc",
};

export const contactTypeArray = [
  "inquiry",
  "contacted",
  "waitlist",
  "prospect",
  "customer",
  "vendor",
  "VIP",
  "contractor",
  "designer",
];

export const abc = ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J"];

export var formatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
});

export const priceItems = {
  "24inchEaves": '24" Eaves',
  birchLam: "Birch Laminate Ceiling Panels",
  bronzeTint: "Bronze Tinted Skylight",
  frenchDoors: "French Door Opening",
  frenchDoorsWindowOpenings: "French Door Window Opening",
  opener: "Electric Skylight Opener",
  package: "Full Kit Package",
  paintedRoof: "Painted Roof",
  "pineT&G": "Pine T&G Ceiling Panels",
  rafters2x12: "2x12 Rafters",
  roofPackage: "Roof Package",
  wallHeight9: "9ft Walls",
  wallHeight10: "10ft Walls",
  wallHeight11: "11ft Walls",
  wallHeight12: "12ft Walls",
  wallHeight14: "14ft Walls",
};

export const kitSizes = {
  birch: "20FT",
  maple: "25FT",
  cedar: "30FT",
  ponderosa: "35FT",
  sequoia: "41FT",
};

export const newForm = [
  {
    createDate: new Date(),
    id: v4(),
    size: null,
    items: [
      { amount: 0, id: v4(), tax: true, title: "" },
      { amount: 0, id: v4(), tax: true, title: "WALLS", category: [] },
      { amount: 0, id: v4(), tax: true, title: "WINDOWS/DOORS", category: [] },
      { amount: 0, id: v4(), tax: true, title: "ROOF/CEILING", category: [] },
      {
        amount: 0,
        id: v4(),
        tax: true,
        title: "DESIGN/ENGINEERING",
        category: [],
      },
      { amount: 0, id: v4(), tax: true, title: "SHIPPING", category: [] },
    ],
  },
];
